import { useQuery } from '@tanstack/react-query'

import { useApi } from '@fortem-monorepo/react-spa'
import { Prices } from '@fortem-monorepo/web-sdk'

import { OverrideQueryOptions } from '@/react-query/queries/ic-report/hooks'

import { queryKeys } from './keys'

type Api = ReturnType<typeof useApi>

export const usePriceValidationQuery = (
  params: Prices.GetPriceValidationParams,
  options: OverrideQueryOptions<Api['prices']['eod']['getValidation']> = {},
) => {
  const api = useApi()

  return useQuery({
    queryKey: queryKeys.eod.validation(params),
    queryFn: () => api.prices.eod.getValidation(params),
    enabled: !!params.fund_name && !!params.value_date && !!params.value_date_mo,
    ...options,
  })
}

export const usePriceValidationImpactQuery = (
  params: Prices.GetPriceValidationParams,
  options: OverrideQueryOptions<Api['prices']['eod']['getValidationImpact']> = {},
) => {
  const api = useApi()

  return useQuery({
    queryKey: queryKeys.eod.validationImpact(params),
    queryFn: () => api.prices.eod.getValidationImpact(params),
    enabled: !!params.fund_name && !!params.value_date && !!params.value_date_mo,
    ...options,
  })
}
